import { useAtom } from 'jotai';
import { useMemo } from 'react';
import useSWR from 'swr';
import zipState from 'zip-state';
import { utilityCoAtom } from '../atoms/form-atoms';

interface TargetOffsetLimits {
    minOffset: number | null;
    maxOffset: number | null;
    zipCode: string;
}

export function useTargetOffsetLimits(zipCode: string) {
    const [utilityCo] = useAtom(utilityCoAtom);

    // Get state from zipcode using zip-state
    const state = useMemo(() => zipState(zipCode), [zipCode]);

    const { data, error, isLoading } = useSWR<TargetOffsetLimits>(
        zipCode && utilityCo && utilityCo.length > 0 && state
            ? `/api/target-offset?utilityCo=${encodeURIComponent(utilityCo)}&state=${state}`
            : null,
        async (url: string) => {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error('Failed to fetch target offset limits');
            }
            return response.json();
        }
    );

    return {
        limits: data,
        isLoading,
        error,
    };
}
